// rtk设置
export default {
    deviceServiceNumber: 'Сервисный номер устройства',
    currentStatus: 'Текущее состояние',
    validUntil: 'Годен до',
    assigned: 'Назначенный',
    unassigned: 'Не назначен',
    inactivated: 'инактивирован',
    inService: 'в сервисе',
    expired: 'истекший',
}